import React from "react";
import { Button, Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import { withFirebase } from "../Firebase";

const useStyles = makeStyles((theme) => ({
  button: {
    background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)',
    color: '#ffffff',
    padding: theme.spacing(1.5),
    borderRadius: '8px',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 15px rgba(255, 107, 107, 0.4)',
    '&:hover': {
      background: 'linear-gradient(135deg, #ff5252 0%, #dc4c5f 100%)',
      boxShadow: '0 6px 20px rgba(255, 107, 107, 0.6)',
    },
  },
  helperText: {
    color: '#92929f',
    fontSize: '0.875rem',
    marginBottom: theme.spacing(2),
  },
}));

const SignOutButton = ({ firebase }) => {
  const classes = useStyles();
  
  return (
    <Box>
      <Typography variant="body2" className={classes.helperText}>
        Encerre sua sessão atual de forma segura
      </Typography>
      <Button 
        type="button" 
        onClick={firebase.doSignOut}
        fullWidth
        className={classes.button}
        startIcon={<ExitToAppIcon />}
      >
        Sair da Conta
      </Button>
    </Box>
  );
};

export default withFirebase(SignOutButton);
